import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useBotUser } from '@/stores/useBotUser';
import type { DraftUser } from '@/stores/useBotUser';
import type { GuestTicketForm, OpenRequestModalUserProps } from './openRequestForm.types';

const mapGuestDraft = (g: DraftUser): Partial<GuestTicketForm> => ({
  name: g.name ?? '',
  email: g.email ?? '',
  phone: g.phone ?? '',
  description: g.description ?? '',
});

/**
 * Snapshot of {@link useBotUser} (Pinia) for {@link OpenRequestModal} (read-only fields + guest draft).
 */
export const useOpenRequestModalUserProps = () => {
  const botUserStore = useBotUser();
  const { guestUser, user, isAuthenticated } = storeToRefs(botUserStore);

  return computed(
    (): OpenRequestModalUserProps => ({
      isLoggedIn: isAuthenticated.value,
      requesterForeignId: String(user.value.foreignId ?? ''),
      accountEmail: String(user.value.email ?? ''),
      accountPhone: String(user.value.phone ?? ''),
      pleasedUserEmail: String(user.value.email ?? ''),
      pleasedUserForeignId: String(user.value.foreignId ?? ''),
      guestFormDraft: guestUser.value ? mapGuestDraft(guestUser.value) : null,
    })
  );
};
